module.exports = __webpack_public_path__ + "static/media/question4.6eb18507.svg";